// Read at call time so tests can toggle the local kill switch; deployed builds always include the step.
const dynamicRuleBuilderEnabled = () =>
  !["1", "true"].includes(String(process.env.VUE_APP_DISABLE_DYNAMIC_RULE_BUILDER).toLowerCase());

function step(config) {
  return {
    completed: false,
    everCompleted: false,
    ...config,
  };
}

// Fresh objects on every call so completion and substeps are not shared across programs.
export function buildSteps({ includeClaimForm = false } = {}) {
  return [
    step({
      key: "details",
      label: "Program Name",
      icon: "mdi-star-check",
    }),
    step({
      key: "timeline",
      label: "Timeline",
      icon: "mdi-calendar-clock",
    }),
    step({
      key: "audience",
      label: "Audience",
      icon: "mdi-account-multiple",
    }),
    ...(dynamicRuleBuilderEnabled()
      ? [
          step({
            key: "dynamic-rule-builder",
            label: "Dynamic rule",
            icon: "mdi-poll",
            fullWidth: true,
          }),
        ]
      : []),
    step({
      key: "reward",
      label: "Reward",
      icon: "mdi-trophy",
    }),
    ...(includeClaimForm
      ? [
          step({
            key: "claim-form",
            label: "Claim form",
            icon: "mdi-magnify-plus",
          }),
        ]
      : []),
    step({
      key: "summary-card-metrics",
      label: "Summary card metrics",
      icon: "mdi-view-grid",
      showPreview: true,
    }),
    step({
      key: "detail-page-metrics",
      label: "Detail page metrics",
      icon: "mdi-view-grid",
      showPreview: true,
    }),
    step({
      key: "detail-page-tabs",
      label: "Detail page tabs",
      icon: "mdi-tab",
      nonLinearSubsteps: true,
      parentClickableWithSubsteps: true,
      substeps: [],
    }),
    step({
      key: "program-messages",
      label: "Program messages",
      icon: "mdi-email",
      nonLinearSubsteps: true,
      parentClickableWithSubsteps: true,
      substeps: [],
      error: false,
    }),
    step({
      key: "confirm",
      label: "Confirm and publish",
      icon: "mdi-rocket-launch",
    }),
  ];
}

// Reuses steps that are already on screen so labels, completion, and substeps survive a reorder.
export function applySteps(currentSteps, { isEditing = false, isClaimProgram = false } = {}) {
  const existing = new Map((currentSteps || []).map((item) => [item.key, item]));
  return buildSteps({ includeClaimForm: isEditing && isClaimProgram }).map(
    (item) => existing.get(item.key) || item
  );
}
